"use client";

import Link from "next/link";
import Image from "next/image";
import { Instagram, Facebook, Twitter } from "lucide-react";

const quickLinks = [
  { label: "Features", href: "/#features" },
  { label: "Pricing", href: "/#pricing" },
  { label: "FAQ", href: "/#faq" },
  { label: "Guide", href: "/guide" },
];
const socialLinks = [
  {
    label: "Instagram",
    href: "https://instagram.com/yourhandle",
    icon: Instagram,
  },
  {
    label: "Facebook",
    href: "https://facebook.com/yourhandle",
    icon: Facebook,
  },
  { label: "Twitter", href: "https://twitter.com/yourhandle", icon: Twitter },
];
const companyLinks = [
  { label: "About", href: "/about" },
  { label: "Reseller", href: "/reseller" },
  { label: "Affiliates", href: "/affiliates" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/contact" },
];
const legalLinks = [
  { label: "Terms of Service", href: "/terms" },
  { label: "Privacy Policy", href: "/privacy" },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card border-t-2 border-primary mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div>
            <Link
              href="/"
              onClick={(e) => {
                if (window.location.pathname === "/" && window.location.hash) {
                  e.preventDefault();
                  history.replaceState(null, "", "/");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
            >
              <Image src="/icon0.svg" alt="Logo" height={200} width={200} />
            </Link>
            <p className="font-sans text-sm text-muted-foreground mt-4 leading-relaxed">
              Premium IPTV services
              <br />
              for the modern viewer.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-xs font-extrabold text-foreground uppercase tracking-widest mb-5">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="font-sans text-sm text-muted-foreground hover:text-primary border-b border-transparent hover:border-primary transition-colors duration-150 pb-0.5"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading text-xs font-extrabold text-foreground uppercase tracking-widest mb-5">
              Company
            </h4>
            <ul className="space-y-2.5">
              {companyLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="font-sans text-sm text-muted-foreground hover:text-primary border-b border-transparent hover:border-primary transition-colors duration-150 pb-0.5"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-xs font-extrabold text-foreground uppercase tracking-widest mb-5">
              Legal
            </h4>
            <ul className="space-y-2.5">
              {legalLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="font-sans text-sm text-muted-foreground hover:text-primary border-b border-transparent hover:border-primary transition-colors duration-150 pb-0.5"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-border pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-sans text-xs text-muted-foreground order-2 md:order-1">
            © {currentYear} IPTV Live. All rights reserved.
          </p>
          <div className="flex items-center gap-5 order-1 md:order-2">
            {socialLinks.map((link) => {
              const Icon = link.icon;
              return (
                <a
                  key={link.href}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors duration-150"
                  aria-label={link.label}
                >
                  <Icon className="h-5 w-5" />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </footer>
  );
}
